import { StepperContext } from "common/contexts/StepperContext";
import { useContext } from "react";

export function useStepperContext() {
  return useContext(StepperContext);
}
